import { MAIN_EMAIL, PHONE } from "@/content";

export const Footer = ({ t }) => (
  <footer className="py-8" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 lb flex flex-wrap justify-between gap-4">
      <span>Jamal Zgugu</span>
      <span className="flex flex-wrap gap-x-6 gap-y-2 normal-case tracking-normal">
        <a href={`mailto:${MAIN_EMAIL}`} className="hover:text-brass transition-colors duration-200" data-testid="footer-email-link">{MAIN_EMAIL}</a>
        <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="hover:text-brass transition-colors duration-200 whitespace-nowrap" data-testid="footer-phone-link">{PHONE}</a>
      </span>
      <span>{t.footerRight}</span>
    </div>
  </footer>
);
